import { INTEGRATION_TAGS, NAMES_ROUTES } from "@/const/routes.constants"
import { TFunction } from "@/hooks/useTranslation"
import { PARAMS } from "@/pages/IntegrationsPage/const"
import { createSearchParamFromTag } from "@/pages/IntegrationsPage/helpers"

export const TEASERS = {
  KEY_PREFIX: "general.teasers",
  KORTEX_INSTALLED: {
    noActiveSensorsDeployed: (t: TFunction, key?: string) => ({
      title: t(key || `${TEASERS.KEY_PREFIX}.noActiveSensorsDeployed.title`),
      link: {
        url: "/deployments",
        text: t(`${TEASERS.KEY_PREFIX}.noActiveSensorsDeployed.text`)
      }
    })
  },
  SCM_INSTALLED: {
    codeRepoNotConnected: (t: TFunction) => ({
      title: t(`${TEASERS.KEY_PREFIX}.codeRepoNotConnected.title`),
      link: {
        url: `/${NAMES_ROUTES.INTEGRATIONS.ROOT}?${PARAMS.tag}=${createSearchParamFromTag(INTEGRATION_TAGS.sourceControl)}`,
        text: t(`${TEASERS.KEY_PREFIX}.codeRepoNotConnected.text`)
      }
    })
  }
}
